// "use client";

// import { useState } from "react";
// import { motion } from "framer-motion";
// import { useInView } from "framer-motion";
// import { useRef } from "react";
// import Tag from "../ui/tag";
// import Button from "../ui/button";
// import { IoSparkles, IoCalendar, IoMail } from "react-icons/io5";
// import AnimatedIcon from "../ui/animated-icon";
// import CustomModal from "../modal/modal";
// import { modalDataMap } from "../../data/site-data";
// import siteData from "../../data/site-data";
// import BookingModal from "../modal/booking-modal";
// import { useRouter } from "next/navigation";
// import {
//   CodeIcon,
//   TargetIcon,
//   UXConsultingIcon,
//   NetworkIcon,
//   ArtificialIntelligenceIcon,
// } from "../icons";
// import {
//   staggerContainer,
//   staggerItem,
//   fadeInUp,
//   cardHover,
//   textReveal,
//   scrollReveal,
// } from "../../lib/animations";
// import PortfolioModal from "../modal/portfolio-modal";

// // Icon mapping function
// const getIconComponent = (iconName: string) => {
//   const iconMap: {
//     [key: string]: React.ComponentType<{ className?: string }>;
//   } = {
//     CodeIcon,
//     TargetIcon,
//     UXConsultingIcon,
//     NetworkIcon,
//     ArtificialIntelligenceIcon,
//   };

//   return iconMap[iconName] || CodeIcon; // Default fallback
// };

// export default function Features() {
//   const { features } = siteData;
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, amount: 0.1 });
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [open, setOpen] = useState<boolean>(false);
//   const [selectedModalData, setSelectedModalData] = useState(
//     modalDataMap["default"]
//   );
//   const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
//   const router = useRouter();

//   return (
//     <motion.section
//       ref={ref}
//       className="py-20 bg-light"
//       initial="hidden"
//       animate={isInView ? "visible" : "hidden"}
//       variants={staggerContainer}
//     >
//       <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Header Section */}
//         <motion.div className="text-center mb-16" variants={staggerContainer}>
//           {/* Top Tag */}
//           <motion.div className="mb-6" variants={fadeInUp}>
//             <Tag
//               icon={
//                 <AnimatedIcon animation="pulse" className="text-primary">
//                   <IoSparkles />
//                 </AnimatedIcon>
//               }
//               text={features.tag.text}
//               bgColor="light"
//               textColor="primary"
//               borderColor="secondary"
//             />
//           </motion.div>

//           {/* Main Headline */}
//           <motion.h2
//             className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight"
//             variants={textReveal}
//           >
//             {features.title}
//           </motion.h2>

//           {/* Descriptive Text */}
//           <motion.p
//             className="text-lg text-text mb-8 max-w-2xl mx-auto leading-relaxed"
//             variants={textReveal}
//           >
//             {features.description}
//           </motion.p>

//           {/* Call-to-Action Buttons */}
//           <motion.div
//             className="flex flex-col sm:flex-row gap-3 justify-center items-center w-[220px] mx-auto sm:w-auto"
//             variants={staggerContainer}
//           >
//             <motion.div
//               className="flex items-center justify-center gap-2 px-6 py-3 bg-primary text-light font-medium rounded-md transition-colors hover:bg-primary/90 text-sm cursor-pointer w-full sm:w-auto"
//               variants={staggerItem}
//               whileHover={{ scale: 1.05, y: -2 }}
//               whileTap={{ scale: 0.95 }}
//               transition={{ duration: 0.2 }}
//               onClick={() => setIsBookingModalOpen(true)}
//             >
//               {/* <motion.div
//                 whileHover={{ scale: 1.2 }}
//                 transition={{ duration: 0.2 }}
//               >
//                 <IoCalendar className="w-4 h-4" />
//               </motion.div> */}
//               {features.buttons[0].text}
//             </motion.div>

//             <motion.div
//               className="flex items-center justify-center gap-2 px-6 py-3 border border-[#EE746D] text-foreground font-medium rounded-md transition-colors hover:border-primary text-sm cursor-pointer w-full sm:w-auto"
//               variants={staggerItem}
//               whileHover={{ scale: 1.05, y: -2 }}
//               whileTap={{ scale: 0.95 }}
//               transition={{ duration: 0.2 }}
//               onClick={() => router.push("/contact")}
//             >
//               {/* <motion.div
//                 whileHover={{ scale: 1.2 }}
//                 transition={{ duration: 0.2 }}
//               >
//                 <IoMail className="w-4 h-4" />
//               </motion.div> */}
//               {features.buttons[1].text}
//             </motion.div>
//           </motion.div>
//         </motion.div>

//         {/* Feature Cards Grid */}
//         <motion.div
//           className="grid grid-cols-1 md:grid-cols-3 gap-6"
//           variants={staggerContainer}
//         >
//           {/* Top Row - 3 Cards */}
//           {features.features.slice(0, 3).map((feature, index) => {
//             const IconComponent = getIconComponent(feature.icon);

//             return (
//               <motion.div
//                 key={feature.id}
//                 className="bg-primary text-light p-6 rounded-lg shadow-md cursor-pointer"
//                 variants={staggerItem}
//                 custom={index}
//                 whileHover={{
//                   y: -8,
//                   boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
//                   transition: { duration: 0.3, ease: "easeOut" },
//                 }}
//                 initial="initial"
//                 // onClick={() => {
//                 //   const modalKey = feature.id || "default";
//                 //   setSelectedModalData(
//                 //     modalDataMap[modalKey] || modalDataMap["default"]
//                 //   );
//                 //   setIsModalOpen(true);
//                 // }}
//               >
//                 <motion.div
//                   className="content-group"
//                   whileHover={{ x: 5 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   <div className="mb-4">
//                     <AnimatedIcon className="w-6 h-6 text-white">
//                       <IconComponent />
//                     </AnimatedIcon>
//                   </div>
//                   <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
//                   <p className="text-sm opacity-90 leading-relaxed">
//                     {feature.description}
//                   </p>
//                 </motion.div>
//               </motion.div>
//             );
//           })}
//         </motion.div>

//         {/* Bottom Row - 2 Wider Cards */}
//         <motion.div
//           className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6"
//           variants={staggerContainer}
//         >
//           {features.features.slice(3, 5).map((feature, index) => {
//             const IconComponent = getIconComponent(feature.icon);

//             return (
//               <motion.div
//                 key={feature.id}
//                 className="bg-primary text-light p-6 rounded-lg shadow-md cursor-pointer"
//                 variants={staggerItem}
//                 custom={index + 3}
//                 whileHover={{
//                   y: -8,
//                   boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
//                   transition: { duration: 0.3, ease: "easeOut" },
//                 }}
//                 initial="initial"
//                 // onClick={() => {
//                 //   const modalKey = feature.id || "default";
//                 //   setSelectedModalData(
//                 //     modalDataMap[modalKey] || modalDataMap["default"]
//                 //   );
//                 //   setIsModalOpen(true);
//                 // }}
//               >
//                 <motion.div
//                   className="content-group"
//                   whileHover={{ x: 5 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   <div className="mb-4">
//                     <AnimatedIcon className="w-6 h-6 text-white">
//                       <IconComponent />
//                     </AnimatedIcon>
//                   </div>
//                   <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
//                   <p className="text-sm opacity-90 leading-relaxed">
//                     {feature.description}
//                   </p>
//                 </motion.div>
//               </motion.div>
//             );
//           })}
//         </motion.div>
//         <p
//           className="text-[#387FF5] pt-4 text-right cursor-pointer"
//           onClick={() => setOpen(!open)}
//         >
//           View all services {"->"}
//         </p>
//       </div>

//       {/* Features Modal */}
//       <CustomModal
//         open={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         data={selectedModalData}
//       />
//       <BookingModal
//         open={isBookingModalOpen}
//         onClose={() => setIsBookingModalOpen(false)}
//       />
//       <PortfolioModal
//         title={"Services"}
//         open={open}
//         onClose={() => setOpen(false)}
//       />
//     </motion.section>
//   );
// }
"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import {
  Mic,
  ShieldCheck,
  Rocket,
  Handshake,
  ArrowRight,
} from "lucide-react";

const ProductsSection = () => {
  const cards = [
    {
      id: "alliesia",
      title: "Alliesia",
      description:
        "AI voice assistant for smarter task management, workflow, and collaboration.",
      icon: Mic,
      color: "#6366F1",
      bgColor: "rgba(99, 102, 241, 0.1)",
      outcome: "Work organized. Nothing missed.",
      cta: "Explore Alliesia",
      href: "https://alliesia.com",
    },
    {
      id: "whoogy",
      title: "Whoogy",
      description:
        "AI-powered visual QA for pixel perfect figma to web validation.",
      icon: ShieldCheck,
      color: "#10B981",
      bgColor: "rgba(16, 185, 129, 0.1)",
      outcome: "Better testing. Faster releases.",
      cta: "Explore Whoogy",
      href: "https://whoogy.com",
    },
    {
      id: "product-development",
      title: "Product Development",
      description:
       "Helping founders turn ideas into scalable AI products and software.",
      icon: Rocket,
      color: "#F59E0B",
      bgColor: "rgba(245, 158, 11, 0.1)",
      outcome: "From idea to launch.",
      cta: "View Case Studies",
      href: "/case-studies",
    },
    {
      id: "partnerships",
      title: "Strategic Partnerships",
      description:
        "Helping startups and businesses build products that scale.",
      icon: Handshake,
      color: "#EC4899",
      bgColor: "rgba(236, 72, 153, 0.1)",
      outcome: "Building together.",
      cta: "Partner With Us",
      href: "/contact",
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-white"> <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-12 md:mb-16"
      >
        <h2
          className="text-[28px] sm:text-[34px] md:text-[40px] text-[#141414] mb-4"
          style={{
            fontWeight: 500,
            lineHeight: 1.18,
            letterSpacing: "-0.015em",
          }}
        >
          Building AI Innovation Beyond Client Work
        </h2>

        <p
          className="text-[16px] md:text-[17px] text-[#4B5563] max-w-[720px] mx-auto"
          style={{
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          Alongside client projects, we build our own AI-powered products to solve everyday business challenges.
        </p>
      </motion.div>

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {cards.map((card, index) => {
          const Icon = card.icon;

          return (
            <motion.div
              key={card.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                delay: index * 0.1,
                duration: 0.5,
              }}
              className="group rounded-xl p-6 border border-gray-100 hover:border-gray-200 transition-all duration-300 flex flex-col h-full overflow-hidden relative"
              style={{
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                background: `linear-gradient(135deg, ${card.bgColor} 0%, white 50%, white 100%)`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow =
                  "0 8px 24px rgba(0, 0, 0, 0.08)";
                e.currentTarget.style.transform = "translateY(-4px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow =
                  "0 2px 8px rgba(0, 0, 0, 0.04)";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              {/* Icon */}
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center mb-5"
                style={{
                  backgroundColor: card.bgColor,
                }}
              >
                <Icon
                  className="h-6 w-6"
                  style={{
                    color: card.color,
                  }}
                  strokeWidth={1.5}
                />
              </div>

              {/* Title */}
              <h3
                className="text-[16px] text-[#141414] mb-3"
                style={{
                  fontWeight: 500,
                }}
              >
                {card.title}
              </h3>

              {/* Description */}
              <p
                className="text-[14px] text-[#4B5563] leading-relaxed mb-5 flex-grow"
                style={{
                  fontWeight: 400,
                }}
              >
                {card.description}
              </p>

              {/* CTA */}
              <Link
              target="_blank"
                href={card.href}
                className="inline-flex items-center text-[13px] mb-4 transition-colors"
                style={{
                  color: card.color,
                  fontWeight: 500,
                }}
              >
                {card.cta}
                <ArrowRight className="ml-1 h-3.5 w-3.5" />
              </Link>

              {/* Outcome */}
              {/* <div className="pt-4 border-t border-gray-100 mt-auto">
                <p
                  className="text-[13px] text-[#6B7280]"
                  style={{
                    fontWeight: 500,
                  }}
                >
                  {card.outcome}
                </p>
              </div> */}
            </motion.div>
          );
        })}
      </div>

      {/* Bottom CTA */}
      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.6,
          delay: 0.3,
        }}
        className="text-center"
      >
        <Link
          href="/products"
          className="group inline-flex items-center px-6 py-3 bg-[#2B2B2B] text-white text-[14px] rounded hover:bg-[#1f1f1f] transition-colors duration-200"
          style={{
            fontWeight: 500,
          }}
        >
          Explore Our Products
          <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform duration-200" />
        </Link>
      </motion.div> */}
    </div>
    </section>

  );
};

export default ProductsSection;


